import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import deleteFolderOperation from 'owa-service/lib/operation/deleteFolderOperation';
import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';
import folderId from 'owa-service/lib/factory/folderId';
import deleteFolderRequest from 'owa-service/lib/factory/deleteFolderRequest';

export default function deleteFolderService(
    deleteFolderId: string,
    permanentlyDelete?: boolean
): Promise<SingleResponseMessage> {
    return deleteFolderOperation({
        Header: getJsonRequestHeader(),
        Body: deleteFolderRequest({
            DeleteType: permanentlyDelete ? 'SoftDelete' : 'MoveToDeletedItems',
            FolderIds: [folderId({ Id: deleteFolderId })],
        }),
    }).then(response => {
        return response.Body.ResponseMessages.Items[0];
    });
}
